export default __webpack_public_path__ + "static/media/calculator.53fd38c4.svg";